<script lang="ts" setup>
withDefaults(
  defineProps<{
    text?: string | null
  }>(),
  { text: null }
)
</script>

<template>
  <p
    class="
      !mb-0 text-base leading-normal tracking-[-0.01em] text-main-dark
    "
  >
    {{ text }}
  </p>
</template>
